import ApiService from '../../utils/ApiService';
import Urls from '../../utils/Urls';
import * as Func from '../../utils/functions';
import {removeObjectNull} from "../../utils/functions";
import DashboardResponse from "../mapping/Response/DashboardResponse";

export function getItemUserActivity(params) {
    return new ApiService({
        baseURL: process.env.REACT_APP_API_URL,
        endpoint: Urls.DASHBOARD_USER_ACTIVITY,
        params: params,
        parser: data => new DashboardResponse(data.data.result).exportUserActivity(),
    }).get();
}

export function getItemCityFilter(params) {
    return new ApiService({
        baseURL: process.env.REACT_APP_API_URL,
        endpoint: Urls.DASHBOARD_CITY_FILTER,
        params: params,
        parser: data => new DashboardResponse(data.data.result).exportCityFilter(),
    }).get();
}

export function getAllDashboard(params = {}) {
    return new Promise((resolve) => {
        return Promise.all([
            getItemUserActivity(params).catch((e) => {
                console.log('===== getAllDashboard service error', e)
            }),
            getItemCityFilter(params).catch((e) => {
                console.log('===== getAllDashboard service error', e)
            })
        ]).then((responses) => {
            const userActivity = responses[0],
                cityFilter = responses[1];
            return resolve({userActivity, cityFilter});
        }).catch((e) => {
            console.log('===== getAllDashboard service error 111', e)
            resolve({})
        })
    })
}
